import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import formatWeight from '../../utils/formatWeight';

const flatLicences = { P: 'Flat', A: 'Apprentice', M: 'Amateur', X: 'Retired' };

const jumpLicences = {
    P: { IRE: 'Jumps', GB: 'Jumps' },
    C: { IRE: 'Claiming Professional', GB: 'Conditional' },
    M: { IRE: 'Amateur', GB: 'Amateur' },
    X: { IRE: 'Retired', GB: 'Retired' },
};

const JockeyNameRow = ({ profile: {
    styleName,
    flatJockeyTypeCode: flat,
    jumpJockeyTypeCode: jump,
    countryCode: country,
    lowestRidingWeight: weight,
} }) => {
    const licenceNames = [flatLicences[flat], jump && jumpLicences[jump][country]];
    const licence = _(licenceNames).compact().uniq().join(' & ');

    return (
        <div className="mp-nameRow">
            <div className="mp-nameRow__block">
                <h1 className="mp-nameRow__name">{ styleName }</h1>
                {
                    licence &&
                        <h2 className="mp-nameRow__licenceRow">Licence&nbsp;
                            <span className="mp-nameRow__licence">{ licence }</span>
                        </h2>
                }
                <div className="mp-nameRow__weightRow">
                    Lowest riding weight in last 12 months&nbsp;
                    <div className="mp-nameRow__weight">
                        { weight ? formatWeight(weight) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

JockeyNameRow.propTypes = {
    profile: PropTypes.shape({
        styleName: PropTypes.string.isRequired,
        flatJockeyTypeCode: PropTypes.string,
        jumpJockeyTypeCode: PropTypes.string,
        countryCode: PropTypes.string,
        lowestRidingWeight: PropTypes.number,
    }).isRequired,
};

export default JockeyNameRow;



// WEBPACK FOOTER //
// ./src/js/human/nameRow/JockeyNameRow.jsx